<div class="vstack gap-2 h-100" data-testid="booking-policy-step">
    <quill-view
        [content]="policyContent"
        style="max-height: 65vh; overflow: auto;"
        data-testid="booking-policy-content"
    >
    </quill-view>
    <button
        type="button"
        class="btn btn-primary mb-0"
        appVenueColour
        [primaryColour]="venue.primaryColour"
        data-testid="booking-policy-accept"
        (click)="acceptedPolicy.emit()"
    >
        Accept
    </button>
</div>
